import { getItemsIds } from '../../../../utils/common'

export function hasFileWithId(files, id) {
  return getItemsIds(files)?.includes(id)
}
